// dashboard.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from "../../services/login.service";
import { AbaEnum } from "../../enums/aba.enum";
import { SharedMarcacaoService } from "../../services/shared-marcacao.service";
import { NavegacaoPorAbasService } from "../../services/navegacao-por-abas.service";
import { ToastrService } from "ngx-toastr";
import { MarcacaoModel } from "../../models/marcacao.model";
import { MarcacaoService } from "../../services/marcacao.service";
import { firstValueFrom } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy { // 🟢 Implemente o OnDestroy
  public aba: AbaEnum = AbaEnum.Agenda;
  public emAtendimento: boolean = false;
  public atendimentoSelecionado: MarcacaoModel | undefined = undefined;
  private ignorarNavegacaoAutomatica: boolean = false;
  mostrarModalSenha = false;
  formSenha!: FormGroup;
  submetido = false;
  loading = false;

  msgErro = '';
  msgSucesso = '';

  verSenhaAtual: boolean = false;
  verNovaSenha: boolean = false;
  verConfirmacao: boolean = false;
  public versaoApp: string = 'Carregando...';


  private autoSaveIntervalId: any;

  constructor(protected router: Router,
    private fb: FormBuilder,
    protected loginService: LoginService,
    protected marcacaoService: MarcacaoService,
    protected sharedMarcacaoService: SharedMarcacaoService,
    protected navegacaoPorAbasService: NavegacaoPorAbasService,
    private http: HttpClient,
    private toastrService: ToastrService) {
    
    this.navegacaoPorAbasService.abaAtual.subscribe((aba) => {
      this.aba = aba;
    });

    this.sharedMarcacaoService.marcacaoAtual.subscribe((res) => {
  this.atendimentoSelecionado = res;
  
  this.emAtendimento = this.atendimentoSelecionado !== undefined;

  // 2. Mantém a regra de navegação automática apenas se estiver na Agenda
  if (this.aba === AbaEnum.Agenda && this.atendimentoSelecionado !== undefined && !this.ignorarNavegacaoAutomatica) {
    this.navegacaoPorAbasService.irParaAba(AbaEnum.DadosAtendimento);
  }
});
  }

  ngOnInit(): void {
    this.formSenha = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, 
      Validators.minLength(6),
      Validators.pattern(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{6,}$/)]],
      passwordConfirmation: ['', Validators.required]
    }, {
      validator: this.compararSenhas
    });
    
    this.autoSaveIntervalId = setInterval(() => {
      this.verificarESalvarAutomaticamente();
    }, 1200000); // 20 minutos em milissegundos

    this.buscarVersaoDoServidor();
  }

  
  ngOnDestroy(): void {
    if (this.autoSaveIntervalId) {
      clearInterval(this.autoSaveIntervalId);
    }
  }

  private buscarVersaoDoServidor() {
  const url = `/assets/version.json?t=${new Date().getTime()}`;

  this.http.get<any>(url).subscribe(
    (response: any) => { 
      if (response && response.version) {
        this.versaoApp = response.version;
      }
    },
    (error: any) => { 
      console.error('Erro ao buscar a versão:', error);
      this.versaoApp = 'Desconhecida';
    }
  );
}

  // 🟢 LÓGICA DO SALVAMENTO AUTOMÁTICO
  private verificarESalvarAutomaticamente() {
    // Aplica-se apenas se estiver em atendimento e nas abas de 1 a 6 
    // Ignora Agenda (0) e Prontuários Avulsos (7)
    if (
      this.emAtendimento && 
      this.aba >= AbaEnum.DadosAtendimento && 
      this.aba !== AbaEnum.ProntuariosAvulsos
    ) {
      this.salvarAtendimento(true); // Passa 'true' para o modo silencioso
    }
  }

  get f() { return this.formSenha.controls; }
  
  compararSenhas(group: FormGroup) {
    const pass = group.get('newPassword')?.value;
    const confirm = group.get('passwordConfirmation')?.value;   
    return pass === confirm ? null : { notSame: true };
  }

  // --- AÇÕES DO MODAL --- (Mantidas sem alteração)
  abrirModalAlterarSenha() {
    this.mostrarModalSenha = true;
    this.submetido = false;
    this.msgErro = '';
    this.msgSucesso = '';
    this.verSenhaAtual = false;
    this.verNovaSenha = false;
    this.verConfirmacao = false;
    this.formSenha.reset();
  }

  fecharModalAlterarSenha() {
    this.mostrarModalSenha = false;
  }  

  salvarNovaSenha() {
    this.submetido = true;
    this.msgErro = '';
    this.msgSucesso = '';

    if (this.formSenha.invalid) {
      return;
    }

    this.loading = true;
    
    const model = {
      currentPassword: this.f['currentPassword'].value,
      newPassword: this.f['newPassword'].value,
      passwordConfirmation: this.f['passwordConfirmation'].value
    };

    this.loginService.alterarSenha(model).subscribe({
      next: (res) => {
        this.loading = false;
        this.msgSucesso = 'Senha alterada com sucesso!';       
       
        setTimeout(() => {
          this.fecharModalAlterarSenha();
        }, 2000);
      },
      error: (e) => {        
        this.loading = false;        
       if (e.error && e.error.data) {
             this.msgErro = e.error.data;
        } else if (typeof e.error === 'string') {
             this.msgErro = e.error;
        } else {
             this.msgErro = e.message || 'Erro ao alterar senha. Verifique se a senha atual está correta.';
        }
      }
    });
  }

  public async selecionarAba(aba: AbaEnum) {
    if (this.aba === aba) {
      return;
    }

    if (aba === AbaEnum.Agenda || aba == AbaEnum.ProntuariosAvulsos) {
      if (this.emAtendimento) {
        const resposta = window.confirm("Você tem certeza que deseja abandonar o atendimento?");
        if (resposta) {
          await this.salvarAtendimento();
          this.emAtendimento = false;
          this.navegacaoPorAbasService.irParaAba(aba);
        }
      } else {
        this.navegacaoPorAbasService.irParaAba(aba);
      }
    } else {
      if (!this.emAtendimento) {
        this.toastrService.warning('Selecione um atendimento antes de continuar.', 'Atenção');
        return;
      }
      this.navegacaoPorAbasService.irParaAba(aba);
      if (this.atendimentoSelecionado !== undefined && !this.emAtendimento) {
        this.emAtendimento = true;
      }
    }
  }

 
  public async salvarAtendimento(silencioso: boolean = false) {
    this.prepararAtendimentoAtualParaSalvar();

    if (this.atendimentoSelecionado === undefined) {
      if (!silencioso) this.toastrService.warning('Selecione um atendimento antes de continuar.', 'Atenção');
      return;
    }

    if (this.atendimentoSelecionado.isTravada) {
      if (!silencioso) this.toastrService.warning('Atendimento já foi realizado ou cancelado.', 'Atenção');
      return;
    }

    this.ignorarNavegacaoAutomatica = true;

    try {
      let resultado;

      if (this.atendimentoSelecionado.seq_Agenda > 0) {
        resultado = await firstValueFrom(this.marcacaoService.update(this.atendimentoSelecionado));
      } else {
        resultado = await firstValueFrom(this.marcacaoService.create(this.atendimentoSelecionado));
      }

      if (!silencioso) {
        
        this.toastrService.success('Atendimento salvo com sucesso!', 'Sucesso');
        this.sharedMarcacaoService.setMarcacaoAtual(resultado.data);
      } else {
        
        if (this.atendimentoSelecionado.seq_Agenda <= 0 && resultado.data?.seq_Agenda > 0) {
           this.atendimentoSelecionado.seq_Agenda = resultado.data.seq_Agenda;
        }
      }

    } catch (error) {      
      if (!silencioso) {
        this.toastrService.error('Ocorreu um erro ao salvar o atendimento.', 'Erro');
      } else {
        // Apenas loga no console para não assustar o usuário
        console.error('Erro no salvamento automático:', error);
      }
    } finally {
      this.ignorarNavegacaoAutomatica = false;
    }
  }

  public finalizarAtendimento() {
    this.prepararAtendimentoAtualParaSalvar();
    if (this.atendimentoSelecionado != undefined) {
      this.atendimentoSelecionado.status_Atendimento = 6; // REALIZADO
      if (this.atendimentoSelecionado.seq_Agenda > 0) {
        this.marcacaoService.update(this.atendimentoSelecionado).subscribe((res) => {
          this.toastrService.success('Atendimento finalizado com sucesso!', 'Sucesso');
          this.sharedMarcacaoService.setMarcacaoAtual(res.data);
        });
      }
    } else {
      this.toastrService.warning('Selecione um atendimento antes de continuar.', 'Atenção');
    }
  }

  public prepararAtendimentoAtualParaSalvar() {
    if (this.atendimentoSelecionado != undefined && !this.atendimentoSelecionado.isTravada) {
      this.atendimentoSelecionado.data_Realizacao_Consulta = new Date();
    }
  }

  public logoff() {
    if (this.aba != AbaEnum.Agenda) {
      if (this.emAtendimento) {
        const resposta = window.confirm('Você tem certeza que deseja abandonar o atendimento?');
        if (resposta) {
          this.loginService.logout();
        }
      }
    } else {
      this.loginService.logout();
    }
  }

  protected readonly AbaEnum = AbaEnum;
}